import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AccountsLanding from '../Components/Accounts/AccountsLanding';

class AccountsContainer extends Component {
    constructor(props) {
        super(props);

        let us = JSON.parse(localStorage.getItem('user'));
        let username = us.user.email;
        let name = us.user.name;

        this.state = {
            username: username,
            apikey: us.user.apikey,
            name: name
        }

    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} username={this.state.username} apikey={this.state.apikey} shrink={true} />
                <div className="main-body">
                    <AccountsLanding
                        history={this.props.history}
                        username={this.state.username}
                        name={this.state.name}
                        apikey={this.state.apikey} />
                </div>
            </div>
        )
    }
}

export default withAuth(AccountsContainer);